export var fetchMeldungsmodiFromStorage = function () {
    var meldungsmodusFromStorage = localStorage.getItem('rv_meldungsmodus') || '{}';
    var parsedMeldungsmodus = JSON.parse(meldungsmodusFromStorage);
    return Object.keys(parsedMeldungsmodus)
        .reduce(function (acc, cur) {
        if (parsedMeldungsmodus[cur].expire && parsedMeldungsmodus[cur].expire !== null) {
            var expire = new Date(parsedMeldungsmodus[cur].expire);
            var now = new Date();
            if (now <= expire) {
                acc[cur] = parsedMeldungsmodus[cur];
            }
        }
        else {
            acc[cur] = parsedMeldungsmodus[cur];
        }
        return acc;
    }, {});
};
export var writeMeldungsmodiToStorage = function (meldungsmodi) {
    localStorage.setItem('rv_meldungsmodus', JSON.stringify(meldungsmodi));
};
export var addMeldungsmodusToStorage = function (betriebNr, meldungsmodus) {
    var meldungsmodi = fetchMeldungsmodiFromStorage();
    meldungsmodi[betriebNr] = meldungsmodus;
    writeMeldungsmodiToStorage(meldungsmodi);
};
